import React from "react";
import { OptionBox, PageWrapper, StyledLink } from "./components";

const BelinsonMainPage = () => {
  const options = [
    { text: "סרטוני הדרכה", url: "videos" },
    { text: "תרגול קוגניטיבי", url: "games" },
    { text: "תרגול מוטורי", url: "games" },
    { text: "אחר", url: "games" },
    // { text: "תרגול מוטורי", url: "" },
  ];
  return (
    <PageWrapper>
      {options.map((item) => (
        <StyledLink to={`/app/belinson/${item.url}`} key={item.url}>
          <OptionBox>{item.text}</OptionBox>
        </StyledLink>
      ))}
    </PageWrapper>
  );
};

export default BelinsonMainPage;
